var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-field",
    { staticClass: "input", class: { "md-invalid": _vm.errors.length } },
    [
      _vm.label
        ? _c("label", [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "md-input",
        _vm._b(
          {
            attrs: {
              value: _vm.value,
              placeholder: _vm.placeholder,
              disabled: _vm.disabled
            },
            on: { input: _vm.onChange },
            nativeOn: {
              blur: function($event) {
                return _vm.onBlur($event)
              }
            }
          },
          "md-input",
          _vm.inputProps,
          false
        )
      ),
      _vm._v(" "),
      _vm.errors.length
        ? _vm._l(_vm.errors, function(error, index) {
            return _c(
              "span",
              { key: "error-" + index, staticClass: "md-error" },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("errors." + error)) + "\n    "
                )
              ]
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.suffix
        ? _c("div", { staticClass: "suffix" }, [
            _c("span", [_vm._v(_vm._s(_vm.suffix))])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }